import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import type { IconType } from '../../icons/constants';
import Icon, { ICONS } from '../../icons/icon';
import type { FCC } from '../../types/common';

import styles from './notice_ribbon.module.css';

type Props = {
  color?: string;
  className?: string;
  icon?: IconType;
};

type InlineStyles = {
  borderColor?: string;
};

const NoticeRibbon: FCC<PropsWithChildren<Props>> = ({
  // --color-validation-warning-default
  color = '#ffb871',
  icon = ICONS.Warning,
  children,
  className,
}) => {
  const rootStyle: InlineStyles = {
    borderColor: color,
  };
  return (
    <div className={classNames(styles.root, className)} style={rootStyle}>
      <div className={styles.icon_wrap} style={{ backgroundColor: color }}>
        <Icon className={styles.icon} icon={icon} size={20} />
      </div>
      <div className={styles.message}>{children}</div>
    </div>
  );
};

export default NoticeRibbon;
